export default "__VITE_ASSET__Bw4fORFi__"